"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delay = delay;
exports.getLookerDashboardUrl = getLookerDashboardUrl;
exports.getUserSettings = getUserSettings;
exports.updateUserSettings = updateUserSettings;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _http = require("./http");

var _settings = require("../constants/settings");

var _environment = require("../constants/environment");

var REACT_APP_NALA_ENBED_URL = _environment.ENVIRONMENT_VARIABLE_NAMES.REACT_APP_NALA_ENBED_URL,
    REACT_APP_CUSTOMIZR_BASE_URL = _environment.ENVIRONMENT_VARIABLE_NAMES.REACT_APP_CUSTOMIZR_BASE_URL,
    REACT_APP_CUSTOMIZR_SAVED_SEARCH = _environment.ENVIRONMENT_VARIABLE_NAMES.REACT_APP_CUSTOMIZR_SAVED_SEARCH;

function getLookerDashboardUrl(_x, _x2) {
  return _getLookerDashboardUrl.apply(this, arguments);
} // for settings specific to view (network/fulfiller)


function _getLookerDashboardUrl() {
  _getLookerDashboardUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref, _ref2) {
    var accessToken, environment, configurationId, filters, userAttributeValues, url, _yield$postData, data;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            accessToken = _ref.accessToken, environment = _ref.environment;
            configurationId = _ref2.configurationId, filters = _ref2.filters, userAttributeValues = _ref2.userAttributeValues;
            url = "".concat((0, _environment.env)(REACT_APP_NALA_ENBED_URL, environment));
            _context.next = 5;
            return (0, _http.postData)({
              accessToken: accessToken
            }, url, {
              configurationId: configurationId,
              filters: filters,
              userAttributeValues: userAttributeValues
            });

          case 5:
            _yield$postData = _context.sent;
            data = _yield$postData.data;
            return _context.abrupt("return", data);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getLookerDashboardUrl.apply(this, arguments);
}

function getUserSettings(_x3, _x4) {
  return _getUserSettings.apply(this, arguments);
} // for settings specific to view (network/fulfiller)


function _getUserSettings() {
  _getUserSettings = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3, _ref4) {
    var accessToken, environment, _ref4$key, key, settings;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            accessToken = _ref3.accessToken, environment = _ref3.environment;
            _ref4$key = _ref4.key, key = _ref4$key === void 0 ? _settings.NETWORK_SETTINGS : _ref4$key;
            _context2.next = 4;
            return getAllUserSettings({
              accessToken: accessToken,
              environment: environment
            });

          case 4:
            settings = _context2.sent;
            return _context2.abrupt("return", {
              userSavedSearches: settings[key] || [],
              sharedFilterValues: settings[_settings.SHARED_SETTINGS] || {}
            });

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getUserSettings.apply(this, arguments);
}

function updateUserSettings(_x5, _x6) {
  return _updateUserSettings.apply(this, arguments);
}

function _updateUserSettings() {
  _updateUserSettings = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref5, _ref6) {
    var accessToken, environment, _ref6$key, key, updatedUserSettings, updatedSharedSettings, settings, newSettings;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            accessToken = _ref5.accessToken, environment = _ref5.environment;
            _ref6$key = _ref6.key, key = _ref6$key === void 0 ? _settings.NETWORK_SETTINGS : _ref6$key, updatedUserSettings = _ref6.updatedUserSettings, updatedSharedSettings = _ref6.updatedSharedSettings;
            _context3.next = 4;
            return getAllUserSettings({
              accessToken: accessToken,
              environment: environment
            });

          case 4:
            settings = _context3.sent;
            settings[key] = updatedUserSettings;
            if (updatedSharedSettings) settings[_settings.SHARED_SETTINGS] = updatedSharedSettings;
            _context3.next = 9;
            return saveAllUserSettings({
              accessToken: accessToken,
              environment: environment
            }, settings);

          case 9:
            newSettings = _context3.sent;
            return _context3.abrupt("return", {
              updatedSavedSearches: newSettings[key] || [],
              updatedSharedFilters: newSettings[_settings.SHARED_SETTINGS] || {}
            });

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _updateUserSettings.apply(this, arguments);
}

function getAllUserSettings(_x7) {
  return _getAllUserSettings.apply(this, arguments);
}

function _getAllUserSettings() {
  _getAllUserSettings = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref7) {
    var accessToken, environment, url, _yield$getData, data, _error$response;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            accessToken = _ref7.accessToken, environment = _ref7.environment;
            _context4.prev = 1;
            url = "".concat((0, _environment.env)(REACT_APP_CUSTOMIZR_BASE_URL, environment), "/v1/resources/").concat((0, _environment.env)(REACT_APP_CUSTOMIZR_SAVED_SEARCH, environment), "/settings");
            _context4.next = 5;
            return (0, _http.getData)({
              accessToken: accessToken
            }, url);

          case 5:
            _yield$getData = _context4.sent;
            data = _yield$getData.data;

            if (!Array.isArray(data)) {
              _context4.next = 9;
              break;
            }

            return _context4.abrupt("return", {});

          case 9:
            return _context4.abrupt("return", data || {});

          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](1);

            if (!(((_error$response = _context4.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404)) {
              _context4.next = 16;
              break;
            }

            return _context4.abrupt("return", {});

          case 16:
            throw _context4.t0;

          case 17:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 12]]);
  }));
  return _getAllUserSettings.apply(this, arguments);
}

function saveAllUserSettings(_x8, _x9) {
  return _saveAllUserSettings.apply(this, arguments);
} // Helper function for testing. Will be removed later


function _saveAllUserSettings() {
  _saveAllUserSettings = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(_ref8, updatedUserSettings) {
    var accessToken, environment, url, _yield$putData, data;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            accessToken = _ref8.accessToken, environment = _ref8.environment;
            url = "".concat((0, _environment.env)(REACT_APP_CUSTOMIZR_BASE_URL, environment), "/v1/resources/").concat((0, _environment.env)(REACT_APP_CUSTOMIZR_SAVED_SEARCH, environment), "/settings");
            _context5.next = 4;
            return (0, _http.putData)({
              accessToken: accessToken
            }, url, updatedUserSettings);

          case 4:
            _yield$putData = _context5.sent;
            data = _yield$putData.data;
            return _context5.abrupt("return", data);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _saveAllUserSettings.apply(this, arguments);
}

function delay(_x10) {
  return _delay.apply(this, arguments);
}

function _delay() {
  _delay = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(ms) {
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", new Promise(function (resolve) {
              return setTimeout(resolve, ms);
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _delay.apply(this, arguments);
}